import pushToDataLayer from "./pushToDataLayer";
import ecommerceDataTemplate from "./ecommerceDataTemplate";

const addToWishlistEvent = ({
  productId,
  productCode,
  variantId,
  brandName,
  colour,
  title,
  price,
  variants
}) => {
  pushToDataLayer({
    add_to_wishlist: {
      ecommerce: ecommerceDataTemplate({
        productId,
        productCode,
        variantId,
        brand: brandName,
        colour,
        title,
        price,
        variants
      })
    }
  });
};

export default addToWishlistEvent;
